import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useRequestCaseAccess = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const requestCaseAccess = async (caseId: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });
    await fetch(`${APIBaseChronos}/api/case/${caseId}/request-access`, fetchConfig);
  };

  return useMutation({
    mutationFn: requestCaseAccess,
    onSuccess: () => {
      toast.success('Access request sent');
    },
    onError: () => {
      toast.error('Failed to send access request');
    },
  });
};
